import React, { useMemo } from 'react';
import StationIcon from '@this/src/components/shared/icons/station_icon';
import AirportIcon from '@this/src/components/shared/icons/airport_icon';
import type { LegSummaryJson } from '@this/src/domain/select_repository';
import { resolveTravelModeIconType, type SegmentForIcon } from './resolve_travel_mode_icon_type';

interface TravelModeIconProps {
  type: string;
  legSummary?: LegSummaryJson;
  segment?: SegmentForIcon;
  muted?: boolean;
}

const TravelModeIcon = ({ type, legSummary, segment, muted = false }: TravelModeIconProps) => {
  const iconType = useMemo(
    () => resolveTravelModeIconType(type, legSummary, segment),
    [type, legSummary, segment]
  );
  const wrapperStyle = useMemo(() => getIconWrapperStyle(muted), [muted]);

  if (iconType === 'walk') {
    return (
      <div style={wrapperStyle}>
        <img src="/images/walk.png" alt="" style={imageIconStyle} />
      </div>
    );
  }

  if (iconType === 'bus') {
    return (
      <div style={wrapperStyle}>
        <img src="/images/bus.png" alt="" style={imageIconStyle} />
      </div>
    );
  }

  if (iconType === 'air') {
    return (
      <div style={wrapperStyle}>
        <AirportIcon />
      </div>
    );
  }

  return (
    <div style={wrapperStyle}>
      <StationIcon />
    </div>
  );
};

const imageIconStyle = {
  height: '16px',
  width: '16px'
} as const;

const getIconWrapperStyle = (muted: boolean) =>
  ({
    width: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    marginRight: '10px',
    opacity: muted ? 0.7 : 1,
    filter: muted ? 'grayscale(1)' : undefined
  } as const);

export default TravelModeIcon;
